// extracted by mini-css-extract-plugin
export default {"table":"dcc_table-table","td":"dcc_table-td","tr":"dcc_table-tr"};